<template>
  <div class='PedidosList'>
    <div class="description">Status:</div>
    <div style="width: 5%">
      <!-- <status-icon
      v-if="data.pedido.status === 0"
      :options="{ width: '20px', height: '20px', action: true }"
      text="Recebido"
      :active="true"
      :optionsLabel="{ marginTop: '50px' }"
      />
      <good-icon
      v-if="data.pedido.status === 'Enviado'"
      :options="{ width: '20px', height: '20px', action: true }"
      text="Concluído"
      :active="true"
      :optionsLabel="{ marginTop: '50px' }"
      /> -->
      {{ data.pedido.status }}
    </div>
    <div class="description">Número:</div>
    <div style="width: 10%">
      <span>#{{ data.pedido.id }}</span>
    </div>
    <div class="description">Itens:</div>
    <div style="width: 25%">
      <div>{{ qtdeItens }} {{ strItens }}</div>
      <div
      v-for="(i, k) in data.pedido.itens"
      :key="k"
      >
        {{ i.qtda + 'x' + i.name }}
      </div>
    </div>
    <div class="description">Endereço:</div>
    <div style="width: 30%">
      {{ data.endereco.endereco }} - {{  data.endereco.numero  }} - {{  data.endereco.bairro  }} - {{ data.endereco.bairro }}
    </div>
    <div style="width: 15%">
      {{ (total + data.pedido.frete).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}
    </div>
    <div style="width: 10%">
      {{ data.pedido.dateCreate }}
    </div>
    <div class="description">Ações:</div>
    <div class="acoes">
      <eyes-icon
      @click="view"
      :options="{ width: '18px', height: '18px', action: true }"
      text="Detalhes"
      :active="true"
      :optionsLabel="{ marginTop: '65px' }"
      />
    </div> 
  </div>
</template>

<script>
import { mapActions } from 'vuex'
//import StatusIcon from '@/components/EnbPainel/Icons/StatusIcon'
import EyesIcon from '@/components/EnbPainel/Icons/EyesIcon'
export default {
  name: 'PedidosList',
  components: { EyesIcon },
  props: ['data'],
  computed: {
    total () {
      return this.data.pedido.itens.map(i => i.preco * i.qtda).reduce((t, n) => t + n, 0)
    },
    qtdeItens () {
      return this.data.pedido.itens.map(i => i.qtda).reduce((t, n) => t + n, 0)
    },
    strItens () {
      return this.qtdeItens > 1 ? 'itens' : 'item'
    }
  },
  methods: {
    ...mapActions(['SetPedidoView']),
    view () {
      this.SetPedidoView(this.data.pedido)
        .then(() => {
          this.$router.push('/pedidos/view')
        })
    }
  }
}
</script>

<style scoped>
.PedidosList {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  padding: 1%;
}

.acoes {
  width: 6%;
  justify-content: center;
  align-items: center;
}

@media (max-width: 500px) {
  .PedidosList {
    display: block;
    width: 80%;
    margin: auto;
  }
  .PedidosList div {
    min-width: max-content;
    margin: auto;
  }
  .description {
    font-weight: bold;
    padding-top: 2%;
    color: #000000;
  }
}

@media screen and (min-width: 500px) {
  .description {
    display: none;
  }
}
</style>
